import { createIcon } from '@chakra-ui/react';

export const VidaIcon = createIcon({
  displayName: 'VidaIcon',
  viewBox: '0 0 41 38',
  path: [
    <path
      key="1"
      d="M3.12392 14.3075C3.26853 14.8616 3.4404 15.4322 3.63467 16.0037C6.15144 23.4367 12.1135 30.052 20.4628 34.7008C28.4936 30.2262 34.3553 23.8894 37.0118 16.79C37.528 15.4158 38.0786 13.8243 38.0786 12.3024C38.0786 7.11586 34.0851 2.89616 29.1772 2.89616C26.1774 2.89616 23.3978 4.47939 21.7418 7.13034L20.5002 9.11903L19.2582 7.13034C17.6022 4.47939 14.8226 2.89616 11.8228 2.89616C6.91489 2.89616 2.92137 7.11586 2.92137 12.3024C2.92137 12.9791 2.98954 13.6535 3.12392 14.3075ZM20.4632 38L19.7694 37.6283C10.4011 32.6131 3.68823 25.2613 0.8657 16.9271C0.645623 16.2788 0.449891 15.6281 0.285321 14.9949L0.270227 14.9278C0.0910494 14.0705 0 13.1877 0 12.3024C0 5.51863 5.30375 0 11.8228 0C15.159 0 18.2815 1.4447 20.5002 3.9436C22.7185 1.4447 25.841 0 29.1772 0C35.6963 0 41 5.51863 41 12.3024C41 14.3061 40.3544 16.1905 39.7497 17.7993C36.7713 25.7589 30.1685 32.8014 21.1576 37.6278L20.4632 38Z"
      fill="#0066F3"
    />
  ]
});
